import styled from 'styled-components';

const base = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background};
  width: 100%;
  height: 100vmin;
`;

const products = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 1rem 0 0 11rem;
  width: 100%;
  height: fit-content;
  background-color: ${(props) => props.theme.colors.background};
`;

const Frame = {
  Base: base,
  Products: products,
};

export default Frame;
